var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { InputText } from 'primereact/inputtext';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var SearchList = /** @class */ (function (_super) {
    __extends(SearchList, _super);
    function SearchList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Id', key: 'id', filter: false, sort: false },
            { name: 'Тип', key: 'type', filter: false, sort: false },
            { name: 'Съчетание', key: 'value', filter: false, sort: false },
            { name: 'Баркодове', key: 'codesAll', filter: false, sort: false },
        ];
        _this.onPage = function (event) {
            _this.props.getAllSearches(event.page + 1);
        };
        _this.editSearch = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editSearch.path.replace(':id', selectedId));
            }
        };
        _this.deleteSearch = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                _this.api
                    .deleteSearch(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Записът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    SearchList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta, search = _a.search;
        var header = (React.createElement("div", { style: { textAlign: 'left' } },
            React.createElement("i", { className: "pi pi-search", style: { margin: '4px 4px 0 0' } }),
            React.createElement(InputText, { type: "search", onInput: search, placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435 \u043F\u043E \u0434\u0443\u043C\u0430 \u0438 \u0431\u0430\u0440\u043A\u043E\u0434" })));
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: "", paginator: true, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), editAction: this.editSearch, onPage: this.onPage, header: header, first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), deleteAction: this.deleteSearch }));
    };
    return SearchList;
}(React.Component));
// @ts-ignore
export default withRouter(SearchList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchList/SearchList.tsx
// module id = 458
// module chunks = 0